<div class="flex">
  <main class="subnav__exists flex" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <section class="w-full h-full pt-16">
      <div
        class="onboarding-content p-12 max-w-4xl mx-auto border border-smoke-darkerlighter rounded bg-white relative z-10 box-shadow">
        <h1 class="mb-4">Business metrics help you understand your business performance</h1>
        <p>Track key metrics, monitor revenue, and gain insights into your property's performance.</p>
        <p>
          This feature is available on our Mogul plan, but you can
          <a class="link" [routerLink]="['/settings/your-plan']">upgrade your subscription</a>
          or
          <a class="link" (click)="contactSales()">schedule a quick call</a>
          to discuss how to include it in your subscription.
        </p>

        <div class="flex flex-row mt-8 gap-4 items-center">
          <sbnb-button (click)="redirectToPlans()" label="Upgrade subscription"></sbnb-button>

          <sbnb-button (click)="contactSales()" type="secondary" label="Or schedule a call!"></sbnb-button>
        </div>
      </div>
    </section>
  </main>
</div>

<sbnb-mobile-sidebar [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
